(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2553:
/***/ (() => {



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_SegmentedView)
});

;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "react"
const external_react_namespaceObject = require("react");
// EXTERNAL MODULE: ./src/SegmentedView/SegmentedView.scss
var SegmentedView = __webpack_require__(2553);
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/SegmentedView/SegmentedView.tsx




var CategoryList = function CategoryList(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    role: "tablist",
    "aria-label": ariaLabel,
    children: children
  });
};
var CategoryListItem = function CategoryListItem(_ref2) {
  var label = _ref2.label,
    index = _ref2.index,
    tabIndex = _ref2.tabIndex,
    selected = _ref2.selected,
    tabRef = _ref2.tabRef,
    onClick = _ref2.onClick,
    handleKeyDown = _ref2.handleKeyDown;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("button", {
    ref: tabRef,
    role: "tab",
    type: "button",
    "aria-selected": selected ? 'true' : 'false',
    "aria-controls": "category-panel-".concat(index + 1),
    id: "category-list-item-".concat(index + 1),
    onClick: onClick,
    tabIndex: tabIndex,
    onKeyDown: handleKeyDown,
    children: label
  });
};
var CategoryPanelGroup = function CategoryPanelGroup(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      children: children
    })
  });
};
var CategoryPanel = function CategoryPanel(_ref4) {
  var index = _ref4.index,
    tabIndex = _ref4.tabIndex,
    children = _ref4.children;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    id: "category-panel-".concat(index + 1),
    role: "tabpanel",
    "aria-labelledby": "category-list-item-".concat(index + 1),
    tabIndex: tabIndex,
    children: children
  });
};
var SegmentedView_SegmentedView = function SegmentedView(_ref5) {
  var _ref5$id = _ref5.id,
    id = _ref5$id === void 0 ? 'SegmentedView' : _ref5$id,
    ariaLabel = _ref5.ariaLabel,
    categoryListItems = _ref5.categoryListItems,
    className = _ref5.className,
    _ref5$fullWidthCatego = _ref5.fullWidthCategoryList,
    fullWidthCategoryList = _ref5$fullWidthCatego === void 0 ? false : _ref5$fullWidthCatego,
    _ref5$initialCategory = _ref5.initialCategoryListItemIndex,
    initialCategoryListItemIndex = _ref5$initialCategory === void 0 ? 0 : _ref5$initialCategory;
  var _useState = (0,external_react_namespaceObject.useState)(initialCategoryListItemIndex),
    _useState2 = slicedToArray_default()(_useState, 2),
    activeCategoryListItemIndex = _useState2[0],
    setActiveCategoryListItemIndex = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(initialCategoryListItemIndex),
    _useState4 = slicedToArray_default()(_useState3, 2),
    focusedCategoryListItemIndex = _useState4[0],
    setFocusedCategoryListItemIndex = _useState4[1];
  var _useState5 = (0,external_react_namespaceObject.useState)(false),
    _useState6 = slicedToArray_default()(_useState5, 2),
    cssTransitionsEnabled = _useState6[0],
    setCssTransitionsEnabled = _useState6[1];
  var containerRef = (0,external_react_namespaceObject.useRef)(null);
  var defaultAbleClasses = fullWidthCategoryList ? 'able-SegmentedView--CategoryListFullWidth' : 'able-SegmentedView';
  var enableTransitionsClass = 'able-SegmentedView--transitions-enabled';
  var componentClassName = "".concat(defaultAbleClasses, " ").concat(className ? className : '');
  var numberOfCategoryListItems = categoryListItems.length;
  if (numberOfCategoryListItems > 3) {
    console.warn('The maximum allowed category list items count is 3. Only the first three category list items will be used if the category list items count is greater than 3.');
  }
  var filteredCategoryListItems = numberOfCategoryListItems <= 3 ? categoryListItems : categoryListItems.slice(0, 3);
  var categoryListItemRefs = filteredCategoryListItems.map(function () {
    return /*#__PURE__*/(0,external_react_namespaceObject.createRef)();
  });
  (0,external_react_namespaceObject.useEffect)(function () {
    if (containerRef && containerRef.current) {
      containerRef.current.style.setProperty('--able-current-category-list-item', activeCategoryListItemIndex.toString());
    }
    if (!cssTransitionsEnabled && activeCategoryListItemIndex !== initialCategoryListItemIndex) {
      // on first change of category from initial value, enable css transitions
      setCssTransitionsEnabled(true);
    }
  }, [activeCategoryListItemIndex]);
  var handleClick = function handleClick(categoryListItemIndex) {
    setActiveCategoryListItemIndex(categoryListItemIndex);
  };
  var setFocus = function setFocus(categoryListItemIndex) {
    var ref = categoryListItemRefs[categoryListItemIndex];
    if (ref.current) {
      ref.current.focus();
      setFocusedCategoryListItemIndex(categoryListItemIndex);
    }
  };
  var focusNextCategoryListItem = function focusNextCategoryListItem(nextCategoryListItemIndex) {
    if (nextCategoryListItemIndex >= numberOfCategoryListItems || nextCategoryListItemIndex < 0) {
      return;
    }
    setFocus(nextCategoryListItemIndex);
  };
  var handleKeyDown = function handleKeyDown(e) {
    var target = e.target;
    var preventEventFlag = false;
    if (e.key === 'ArrowRight') {
      var nextCategoryListItem = target.nextElementSibling;
      if (nextCategoryListItem) {
        var nextCategoryListItemIndex = categoryListItemRefs.findIndex(function (e) {
          return e.current === nextCategoryListItem;
        });
        focusNextCategoryListItem(nextCategoryListItemIndex);
      }
      preventEventFlag = true;
    }
    if (e.key === 'ArrowLeft') {
      var previousCategoryListItem = target.previousElementSibling;
      if (previousCategoryListItem) {
        var previousCategoryListItemIndex = categoryListItemRefs.findIndex(function (e) {
          return e.current === previousCategoryListItem;
        });
        focusNextCategoryListItem(previousCategoryListItemIndex);
      }
      preventEventFlag = true;
    }
    if (e.key === 'Home') {
      focusNextCategoryListItem(0);
      preventEventFlag = true;
    }
    if (e.key === 'End') {
      focusNextCategoryListItem(numberOfCategoryListItems - 1);
      preventEventFlag = true;
    }
    if (e.key === 'Enter' || e.key === ' ') {
      setActiveCategoryListItemIndex(focusedCategoryListItemIndex);
      preventEventFlag = true;
    }
    if (preventEventFlag) {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    id: id,
    className: cssTransitionsEnabled ? "".concat(componentClassName, " ").concat(enableTransitionsClass) : componentClassName,
    ref: containerRef,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(CategoryList, {
      ariaLabel: ariaLabel,
      children: [filteredCategoryListItems.map(function (categoryListItem, index) {
        return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(CategoryListItem, {
          label: categoryListItem.title,
          index: index,
          selected: activeCategoryListItemIndex === index,
          tabIndex: activeCategoryListItemIndex !== index ? -1 : undefined,
          tabRef: categoryListItemRefs[index],
          onClick: function onClick() {
            return handleClick(index);
          },
          handleKeyDown: handleKeyDown
        }, id + "category-list-item-".concat(index));
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {})]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(CategoryPanelGroup, {
      children: filteredCategoryListItems.map(function (categoryListItem, index) {
        return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(CategoryPanel, {
          index: index,
          tabIndex: activeCategoryListItemIndex === index ? 0 : undefined,
          children: categoryListItem.panelContent()
        }, id + "category-panel-".concat(index));
      })
    })]
  });
};
/* harmony default export */ const src_SegmentedView_SegmentedView = (SegmentedView_SegmentedView);
;// ./src/SegmentedView/index.ts

/* harmony default export */ const src_SegmentedView = (src_SegmentedView_SegmentedView);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});